import UserGroupRenderer from "./user_group_renderer"

export default class ATUserGroupRenderer extends UserGroupRenderer {
    /**
     * Build columns for group row
     */
    fillTable(table, group) {
        const tr = document.createElement('tr');
        tr.appendChild(this.buildFolderImgCell(group));
        tr.appendChild(this.buildNameCell(group));
        tr.appendChild(this.buildCountCell(group));
        tr.appendChild(this.buildDeleteCell(group));
        tr.appendChild(this.buildConfirmDeleteCell(group));
        tr.appendChild(this.buildWaitingAnimationCell(group));
        table.appendChild(tr);
    }

}


// WEBPACK FOOTER //
// ./web/js/groupManagement/ATUserGroupRenderer.js